// React
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";

function PaymentKakaopay() {
  // 카카오 간편결제 화면

  const navigate = useNavigate();

  // Function
  useEffect(() => {
    setTimeout(() => {
      navigate("/menu/order/payment/success");
    }, 3000);
  });

  return (
    <>
      <div className='intro-wrap'>
        <img
          className='absolute-logo'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
          style={{ width: 158 }}
        />

        <div
          className='payment-select-wrap'
          style={{ paddingTop: 63, height: "100%" }}
        >
          <div className='payment-select-wrap'>
            <div className='TO-title-1 text-color-gray'>
              QR 코드를 찍어주세요
            </div>
            <div className='qr-box'>
              <img
                className='qr'
                src={"/assets/images/menu/qr.png"}
                alt='qr code'
              />
            </div>
          </div>
          <div
            className='basic-btn white TO-button-1 pointer'
            style={{ alignSelf: "flex-start" }}
            onClick={() => {
              navigate("/menu/order/payment");
            }}
          >
            이전으로
          </div>
        </div>
      </div>
    </>
  );
}
export default PaymentKakaopay;
